export const MEMBER_QR_PREFIX = 'XIAOMA:MEMBER:';

export const parseMemberQrValue = (text: string): number | null => {
  const trimmed = text.trim();
  if (!trimmed.startsWith(MEMBER_QR_PREFIX)) return null;

  const memberId = Number(trimmed.slice(MEMBER_QR_PREFIX.length));
  return Number.isNaN(memberId) ? null : memberId;
};
